import { useAppSettingsStore } from '../stores/appSettingsStore';

// --- Chart theme (JS props, unreachable by `dark:` classes) --------------

/** Light/dark pairs for chart chrome (axis/grid/reference lines/tooltip box).
 * Series/status colours (brand greens/reds/blues, per-quadrant/category fills) stay
 * identical across themes by design — only this chrome remaps for contrast
 * against the dark card background. */
const CHART_CHROME = {
  axisTick: { light: '#667085', dark: '#9CA3AF' },
  gridLine: { light: '#f1f5f9', dark: '#1E3A4E' },
  referenceLine: { light: '#D1D5DB', dark: '#374151' },
  cursorFill: { light: 'rgba(102,112,133,0.08)', dark: 'rgba(156,163,175,0.12)' },
  tooltipBg: { light: '#FFFFFF', dark: '#0E2B42' },
  tooltipBorder: { light: '#E5E7EB', dark: '#1E3A4E' },
  tooltipText: { light: '#101828', dark: '#F9FAFB' },
};

/** Reads the active theme once per chart so axis/grid/tooltip colours passed
 * as recharts/chart.js JS props can branch consistently across every chart,
 * instead of each chart re-reading the store and picking its own values. */
export const useChartTheme = () => {
  const darkMode = useAppSettingsStore((s) => s.darkMode);
  const pick = (pair: { light: string; dark: string }) => (darkMode ? pair.dark : pair.light);
  return {
    darkMode,
    axisTick: pick(CHART_CHROME.axisTick),
    gridLine: pick(CHART_CHROME.gridLine),
    referenceLine: pick(CHART_CHROME.referenceLine),
    cursorFill: pick(CHART_CHROME.cursorFill),
    tooltipBg: pick(CHART_CHROME.tooltipBg),
    tooltipBorder: pick(CHART_CHROME.tooltipBorder),
    tooltipText: pick(CHART_CHROME.tooltipText),
  };
};
